import { render, staticRenderFns } from "./ApiLoadingController.vue?vue&type=template&id=4b80ce58&"
import script from "./ApiLoadingController.vue?vue&type=script&lang=js&"
export * from "./ApiLoadingController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports